import axios from "axios";
import { API_ROOT } from "../constant/config";
import store from "../store";


//create instance
const JsonInterceptor = axios.create({
  baseURL: API_ROOT,
});

// // Add a request interceptor
JsonInterceptor.interceptors.request.use(
  async (config) => {
    const { auth } = store.getState();
    const {authToken} = auth;
    if (authToken) {
      config.headers.Authorization = authToken;
      config.headers["x-api-key"] = "5U8DEHBH7X5HRH0Y08ZF";
      config.headers["x-api-secret"] = "5SKKT392TPCE109O690B";
    }
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    if (error.response && error.response) {
      return Promise.reject(error.response);
    }
    return Promise.reject(error);
  }
);



export default JsonInterceptor;
